import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import {
  selectRanchPageView,
  RanchPageViewEnum,
} from '../../ranches/ranchesSlice';
import { resetSelectFields, ResetItemsEnum } from '../../select/selectSlice';

// This hook resets the block detail view when in ranch summary view or when changing scans to avoid showing stale data
export function useResetBlockDetail() {
  const dispatch = useAppDispatch();
  const ranchPageView = useAppSelector(selectRanchPageView);

  // Clear neighbor points when on ranch summary view to avoid stale data showing up in image viewer
  useEffect(() => {
    if (ranchPageView === RanchPageViewEnum.ranchSummary) {
      dispatch(
        resetSelectFields([
          ResetItemsEnum.RowNum,
          ResetItemsEnum.RowsideId,
          ResetItemsEnum.PointId,
          ResetItemsEnum.HoverRowNum,
          ResetItemsEnum.HoverRowsideId,
        ])
      );
    }
  }, [ranchPageView]);
}
